import React from 'react';
import styled from 'styled-components';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import Spinner from '../pages/signup-uga/components/Spinner';

const LoaderBG = styled.div<{ isVisible: boolean; isActive: boolean }>`
  display: ${(props) => (props.isActive ? 'block' : 'none')};
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.3s;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1;
`;

export const Loader: React.FunctionComponent<{ isVisible: boolean; isActive: boolean }> = (props) => {
  return (
    <>
      <LoaderBG isVisible={props.isVisible} isActive={props.isActive}>
        <Spinner />
      </LoaderBG>
      {props.children}
    </>
  );
};

export const withLoader = () => (Component: React.ComponentType) => {
  const PageLoader = (props: any) => (
    <Loader isVisible={props.isVisible} isActive={props.isActive}>
      <Component {...props} />
    </Loader>
  );
  return compose(
    withStateHandlers(
      { isVisible: true, isActive: true },
      {
        setIsVisible: () => (isVisible) => ({ isVisible }),
        setIsActive: () => (isActive) => ({ isActive }),
      }
    ),
    lifecycle({
      componentDidMount() {
        setTimeout(() => this.setState({ isVisible: false }), 300);
        setTimeout(() => this.setState({ isActive: false }), 600);
      },
    })
  )(PageLoader);
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/PageLoader.tsx